import {
  OrderForAnalyticsQueryQuery,
  OrderForAnalyticsQueryQueryVariables
} from '@data/__generated__/types.main'
import {EVENTS} from '@helpers/analytics/events'
import {PurchaseTaxonomies} from '@helpers/analytics/events/purchase'
import {sendEvent} from '@helpers/analytics/sendEvents'
import useTrackEcommerceEvent, {ECOMMERCE_EVENTS} from '@helpers/track/useTrackEcommerceEvent'
import useEffect from '@hooks/useEffect'
import useEventsBaseProperties from '@hooks/useEventsBaseProperties'
import useTrack from '@hooks/useTrack'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useClient, useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

import {trackAnalyticsQuery} from './trackAnalyticsQuery.main'

export default function Track() {
  const {order} = useOrder()

  const track = useTrack()
  const mutate = useMutate()
  const client = useClient()
  const eventBaseProperties = useEventsBaseProperties()

  const trackEcommerceEvent = useTrackEcommerceEvent()

  const informTrack = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation TrackingV2InformOrderTrack($orderId: ID) {
            informOrderTrack(orderId: $orderId) {
              _id
              didTrack
            }
          }
        `,
        variables: {orderId: order._id},
        refetchQueries: ['TrackingV2GetOrder']
      })
    } catch (error) {}
  }

  useEffect(() => {
    track('viewPage', {path: '/track', orderId: order._id})
  }, [order._id])

  useEffect(() => {
    if (order.didTrack || order.paymentStatus !== 'done') return

    sendEvent<PurchaseTaxonomies['webOrderConfirmed']>(EVENTS.purchase.webOrderConfirmed, {
      payMethod: order.paymentType,
      payStatus: order.paymentType === 'cash' ? order.paymentStatus : order.transaction?.status,
      cardType: order.transaction?.cardType,
      orderId: order._id,
      ...eventBaseProperties
    })

    client
      .query<OrderForAnalyticsQueryQuery, OrderForAnalyticsQueryQueryVariables>({
        query: trackAnalyticsQuery,
        variables: {orderId: order._id}
      })
      .then(result => {
        const newOrder = result.data?.order
        trackEcommerceEvent(ECOMMERCE_EVENTS.PURCHASE, {order: newOrder})
      })

    informTrack()
  }, [order.didTrack, order.paymentStatus])

  return null
}
